module.exports = __webpack_public_path__ + "img/jordbruk_paavirkning_jordbearbeiding_og_husdyr.ce9a4d36.jpg";